import service from '../service/area'
import CONSTANT from '../constant/area'
import { Indicator } from 'mint-ui'
import _ from 'underscore'
export default {
    getProvince ({commit}, data) {
        // Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getProvince(data).then(result => {
                resolve(result)
                commit(CONSTANT.AREA_GETPROVINCE_SUCCESS, result)
                // Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.AREA_GETPROVINCE_ERROR, e)
                commit('rootApperError', e)
                // Indicator.close();
            })
        })
    },
    getCity ({commit}, data) {
        // Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCity(data).then(result => {
                resolve(result)
                commit(CONSTANT.AREA_GETCITY_SUCCESS, result)
                // Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.AREA_GETCITY_ERROR, e)
                commit('rootApperError', e)
                // Indicator.close();
            })
        })
    },
    getDistrict ({commit}, data) {
        // Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getDistrict(data).then(result => {
                resolve(result)
                commit(CONSTANT.AREA_GETDISTRICT_SUCCESS, result)
                // Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.AREA_GETDISTRICT_ERROR, e)
                commit('rootApperError', e)
                // Indicator.close();
            })
        })
    },
    /*yeoman-template-point-1*/
}